import prod1 from "../assets/images/gold-bracelet-jewelry-white-isolated-background1.png";
import prod2 from "../assets/images/sabrianna-kuko1hX_kXw-unsplash1.png";
import prod3 from "../assets/images/golden-ring-isolated-white-background1.png";
import prod4 from "../assets/images/prod4.png";
import img1 from "../assets/images/Maskgroup1.png";
import img2 from "../assets/images/Maskgroup2.png";
import img3 from "../assets/images/Maskgroup3.png";
import img4 from "../assets/images/Maskgroup4.png";
import img6 from "../assets/images/Maskgroup6.png";
import img7 from "../assets/images/Maskgroup7.png";
import img8 from "../assets/images/Maskgroup8.png";

export const HOME_DATA = {
  text1: {
    title: "Vestibulum Aliquam Porta Eros",
    banner: "Unique jewelry, rare gems, and exquisite pieces!",
  },
  text2: {
    title: "About Us",
    banner: "We make sparkly magic happen",
    passage:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae massa sit.",
    img1: img1,
    img2: img2,
  },
  text3: {
    title: "lastest Collection",
    banner: "weekly best seller",
  },
  text4: {
    title: "One & Only",
    banner: "TRUE UNIQUE STYLE",
    passage:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae massa sit.",
    img1: img3,
    img2: img4,
  },
  text5: {
    title: "Hightlights",
    banner: "bride & groom collection",
    passage:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque vitae massa sit.",
    img1: img3,
    img2: img4,
  },
};

export const PRODUCTS = [
  {
    name: "Vestibulum aliquam",
    price: "$1356",
    imgUrl: prod1,
  },
  {
    name: "Quisque sed",
    price: "$1587",
    imgUrl: prod2,
  },
  {
    name: "Duis laoreet",
    price: "$3546",
    imgUrl: prod3,
  },
  {
    name: "Curabitur nec",
    price: "$2435",
    imgUrl: prod4,
  },
];

export const PRODUCTS_SLIDE = [
  {
    name: "Proin Commodo",
    price: "$4668",
    imgUrl: img6,
  },
  {
    name: "Vestibulum Porta",
    price: "$6434",
    imgUrl: img7,
  },
  {
    name: "Nulla Vestibulum",
    price: "$3254",
    imgUrl: img8,
  },
  {
    name: "Curabitur nec",
    price: "$2435",
    imgUrl: img6,
  },
];

export const FOOTER_DATA = {
  SITE_MAP: [
    { title: "Home", url: "/" },
    { title: "About", url: "/about" },
    { title: "Shop", url: "/shop" },
  ],
  SERVICE: [
    { title: "FAQ", url: "#" },
    { title: "Shipping", url: "#" },
    { title: "Tracking", url: "#" },
    { title: "Returns", url: "#" },
  ],
  SOCIAL: [
    { title: "Facebook", url: "https://www.facebook.com/aura.jewelry.2025/" },
    {
      title: "Instagram",
      url: "https://www.instagram.com/aura_jewelry_store.2025",
    },
    { title: "Tiktok", url: "https://www.tiktok.com/@aurajewelry2025" },
    {
      title: "Threads",
      url: "https://www.threads.net/@aura_jewelry_store.2025",
    },
  ],
};
